import { render } from "./AdminHeader.vue?vue&type=template&id=5faa0f2a"
import script from "./AdminHeader.vue?vue&type=script&lang=js"
export * from "./AdminHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/header/AdminHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5faa0f2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5faa0f2a', __exports__)) {
    api.reload('5faa0f2a', __exports__)
  }
  
  module.hot.accept("./AdminHeader.vue?vue&type=template&id=5faa0f2a", () => {
    api.rerender('5faa0f2a', render)
  })

}


export default __exports__